var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 42,
    viewBox: "0 0 36 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 0.1875H31.2497C33.5413 0.1875 35.4163 2.0625 35.4163 4.35417V37.6875C35.4163 39.9792 33.5413 41.8542 31.2497 41.8542H12.4997C10.208 41.8542 8.33301 39.9792 8.33301 37.6875V33.5208H12.4997V37.6875H31.2497V4.35417H12.4997V8.52083H8.33301V4.35417C8.33301 2.0625 10.208 0.1875 12.4997 0.1875Z",
    fill: "#4EB9FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7708 28.5052L17.7083 31.4427L28.125 21.026L17.7083 10.6094L14.7708 13.5469L20.1458 18.9427H0V23.1094H20.1458L14.7708 28.5052Z",
    fill: "#4EB9FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignoutIcon);
export default __webpack_public_path__ + "static/media/signoutIcon.cb6131d5794a11324c2d720a83020627.svg";
export { ForwardRef as ReactComponent };